
$controllers.teamsettings = {
	
	onLoad : function() {},
	
	onUnload : function() {
		$controllers.all.unbindEnterFormSubmissions();
		$views.teamsettings.nameEditable.destroy();
	},
	
	display : function($callback) {
		
		if (!$controllers.all.enforcePagePermissions('teamsettings')) { return false; }
		$controllers.all.showPage('teamsettings', 'contentpage');
		$controllers.all.setNavigation();
		$views.teamsettings.display($callback);
		$controllers.all.handleEnterFormSubmissions();
		
	},
	
	displayFromHelp : function() {
		
		$controllers.teamsettings.display(function() {
			$controllers.all.help(true);
		});
		
	},
	
	removeUser : function($userid) {
		$models.users.deleteItem($userid, function() {
			//$soupmail.notification.message('User account has been removed');
			$views.teamsettings.usersGrid.removeItem($userid);
		});
	},
	
	addUser : function($email) {
		
		// quick validation
		$email = jQuery.trim($email);
		if (!$email || $email == 'Enter an email address') {
			$soupmail.modal.error('Please enter an email address');
			return false;
		}
		var validator = new $soupmail.validator();
		if (!validator.validateEmail($email)) {
			$soupmail.modal.error('Please enter a valid email address');
			return false;
		}
		
		// save team member, then add to grid
		$views.teamsettings.usersGrid.changeItem(Math.floor((Math.random()*100)+1), {_visible: true, _editable:false, _isNewPrependedFolder:true, email: $email, admin: false});
		$views.teamsettings.usersGrid.render();
		$models.teamsettings.inviteUser({ email : $email }, function() {   // success handler
			$views.teamsettings.usersGrid.reset();
			$views.teamsettings.usersGrid.load();
		}, function() {   // error handler
			$views.teamsettings.usersGrid.reset();
			$views.teamsettings.usersGrid.load();
		});
		
	},
	
	resetPassword : function($email) {
		
		$soupmail.modal.question('Are you sure you wish to send a reset password request to this team member?', function() {				
			$data = { email: $email };
			$models.users.getResetPassword($data, function() {
				$soupmail.notification.message('A password confirmation request has been been sent to the team member.');
			});
		});
		
	},
	
	updateUserAdminState : function($userid, $state) {
		
		$models.users.setUserAsAdmin($userid, $state, function($response) {
			$views.teamsettings.usersGrid.changeItem($userid, $response.user);
			$views.teamsettings.usersGrid.render();
		});
		
	}
	
};



// WEBPACK FOOTER //
// ./src/js/controllers/desktop.teamsettings.js